export const messages = {
    methods: {
        notify(message, type, duration) {
            /*noty({
                text: message,
                type: type,
                timeout: duration,
                layout: 'topCenter',
                theme: 'metroui',
                timeout: 2000, // время показа
            });*/

            let title='';
            if(type==='error') {
                title = 'Ошибка.'
            }
            let options = {
                title: title,
                message: message,
                location: 'tc',
                style: type
            };
            $.growl(options);

        }
    }
};